<template>
  <svg
    width="135"
    height="209"
    viewBox="0 0 135 209"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Layer_5" clip-path="url(#clip0_2751_1738)">
      <path
        id="Vector"
        d="M-9.13568e-06 0L0 209L135 209L135 -5.90104e-06L-9.13568e-06 0Z"
        fill="#1CCC77"
      />
      <g id="Group">
        <path
          id="Vector_2"
          d="M-8.30449e-07 171.004L0 190.002L135 190.002L135 171.003L-8.30449e-07 171.004Z"
          fill="#47D18F"
        />
        <path
          id="Vector_3"
          d="M-8.30449e-07 133.002L0 152L135 152L135 133.002L-8.30449e-07 133.002Z"
          fill="#47D18F"
        />
        <path
          id="Vector_4"
          d="M-8.30449e-07 95.0035L0 114.002L135 114.002L135 95.0035L-8.30449e-07 95.0035Z"
          fill="#47D18F"
        />
        <path
          id="Vector_5"
          d="M-8.30449e-07 57.0015L0 76L135 76L135 57.0015L-8.30449e-07 57.0015Z"
          fill="#47D18F"
        />
        <path
          id="Vector_6"
          d="M-8.30449e-07 18.9996L0 37.998L135 37.998L135 18.9996L-8.30449e-07 18.9996Z"
          fill="#47D18F"
        />
      </g>
      <g id="Group_2">
        <path
          id="Vector_7"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.1304 169.943L25.9434 169.943L25.9434 172.12L25.9434 209L30.3175 209L30.3175 174.297L104.678 174.297L104.678 209L109.052 209L109.052 172.12L109.052 169.943L106.865 169.943L28.1304 169.943Z"
          fill="white"
        />
        <path
          id="Vector_8"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M38.1142 75.2518C31.0745 82.2593 26.5523 91.767 25.9999 102.324L-1.90327e-06 102.324L-1.71294e-06 106.678L25.9999 106.678C26.5523 117.234 31.0746 126.742 38.1142 133.75C45.6322 141.233 56.0208 145.865 67.4972 145.865C78.9736 145.865 89.3621 141.233 96.8802 133.75C103.92 126.742 108.442 117.234 108.994 106.678L134.994 106.678L134.994 102.324L108.994 102.324C108.442 91.767 103.92 82.2593 96.8802 75.2518C89.3621 67.768 78.9736 63.1361 67.4972 63.1361C56.0208 63.1361 45.6322 67.768 38.1142 75.2518ZM104.615 102.324L30.3854 102.324C30.9322 92.9689 34.9646 84.5497 41.2125 78.3303C47.9389 71.6346 57.2339 67.4902 67.5028 67.4902C77.7718 67.4902 87.0668 71.6346 93.7932 78.3303C100.041 84.5497 104.074 92.9689 104.62 102.324L104.615 102.324ZM30.3797 106.678L104.615 106.678C104.068 116.032 100.035 124.452 93.7875 130.671C87.0611 137.367 77.7661 141.511 67.4972 141.511C57.2282 141.511 47.9332 137.367 41.2068 130.671C34.9589 124.452 30.9265 116.032 30.3797 106.678Z"
          fill="white"
        />
        <path
          id="Vector_9"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.9434 -0.000652313L25.9434 36.8737L25.9434 39.0508L28.1304 39.0508L106.865 39.0508L109.052 39.0508L109.052 36.8737L109.052 -0.000655946L104.678 -0.000655755L104.678 34.6966L30.3175 34.6966L30.3175 -0.000652504L25.9434 -0.000652313Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2751_1738">
        <rect width="209" height="135" fill="white" transform="translate(0 209) rotate(-90)" />
      </clipPath>
    </defs>
  </svg>
</template>
